import './style.scss';
import RangeSlider from './rangeslider.js';

export default RangeSlider;